export default __webpack_public_path__ + "static/media/carousel-manage-orgs.09699a90.jpg";